export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    if (window.location.hash) {
      const hashValue = window.location.hash.substring(1); // "setup"
      // Try to scroll immediately first
      let element = document.getElementById(hashValue);
      if (element) {
        element.scrollIntoView();
      } else {
        // If element doesn't exist yet, try again after a short delay
        setTimeout(() => {
          element = document.getElementById(hashValue);
          if (element) {
            element.scrollIntoView();
          }
        }, 2000);
      }
    }
  });
});
